<template>
    <section
        class="facetList searchMachine__facetList"
        :class="{isCollapsed: !isOpen}"
    >
        <header
            class="facetList__header"
            @click="toggle"
        >
            <h2 class="facetList__heading">
                <i class="facetList__headerIcon fal fa-chevron-down" />{{ title }}
            </h2>
        </header>
        <ul
            v-if="isOpen"
            class="facetList__list"
        >
            <li
                v-for="{ key, label, doc_count } in facets"
                :key="facetId + `_${key}`"
                class="facetList__item"
            >
                <input
                    :id="facetId + `_${key}`"
                    v-model="appliedFacets"
                    type="checkbox"
                    :value="{ label, value: key, type: facetId }"
                    class="checkbox"
                >
                <label :for="facetId + `_${key}`">{{ label }} <span class="facetList__count">({{ doc_count }})</span></label>
            </li>
        </ul>
    </section>
</template>

<script>
import { mapActions } from 'vuex';
import enquire from 'enquire.js';


export default {

    props: {
        facets: {
            type: Array,
            required: true,
        },
        facetId: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            isOpen: true,
        };
    },
    computed: {
        appliedFacets: {
            get() {
                return this.$store.state.search.appliedFacets;
            },
            set(value) {
                this.replaceFacets(value);
            },
        },
    },
    mounted() {
        const self = this;
        enquire.register('screen and (max-width: 800px)', {
            match() {
                self.isOpen = false;
            },
            unmatch() {
                self.isOpen = true;
            },
        });
    },
    methods: {
        ...mapActions('search', ['replaceFacets']),
        toggle() {
            this.isOpen = !this.isOpen;
        },
    },
};
</script>
